import {
  BCA_BASE_ROUTE,
  BSA_BASE_ROUTE,
  DEPOSIT_ROUTES,
  DEPOSITS_BASE_ROUTE,
} from '../constants';

const isSavingsUrl = (pathname) => pathname?.startsWith(BSA_BASE_ROUTE);

const isCheckingUrl = (pathname) => pathname?.startsWith(BCA_BASE_ROUTE);

const isDepositsUrl = (pathname) => pathname?.startsWith(DEPOSITS_BASE_ROUTE);

const isBusinessBankingUrl = (pathname) => {
  return isSavingsUrl(pathname) || isCheckingUrl(pathname);
};

const isDepositsManageProfileUrl = (pathname) =>
  pathname.endsWith(DEPOSIT_ROUTES.MANAGE_PROFILE);

export {
  isBusinessBankingUrl,
  isCheckingUrl,
  isDepositsManageProfileUrl,
  isSavingsUrl,
  isDepositsUrl,
};
